
import { connect } from 'react-redux';
import ligthSelectionPage from '../components/LigthSelectionPage';
import { changeLinghtning, showInstructionModal } from '../actions';
import { updateMaterialImageOrSetPending } from '../actions/materialImage.ts';
import { stoves } from '../config';
import  localization  from '../helpers/localization'

const mapDispatchToProps = (dispatch, ownProps) => ({  
    lightingChanged: (e) => {
        dispatch(changeLinghtning(e.id,e.fibers));
        dispatch(updateMaterialImageOrSetPending());
    },
    showLightInstructions: () => {
        dispatch(showInstructionModal());
    }
})

const mapStateToProps = (state, ownProps) => {
    return {  
        materialImage: state.materialImage.image,
        previousMaterialImage: state.materialImage.previousImage,
        stoves: stoves,
        loading: state.materialImage.isLoading,
        lightOptions: state.saunaLighting.avalaibleLights.map(l => { l.name = localization[l.localizationString];  return l }),
        selected: state.saunaLighting.selectedLight.id,
        nextPage: ownProps.nextPage
    };
};

const LigthSelectionPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ligthSelectionPage)

export default LigthSelectionPageContainer;
